import { render, staticRenderFns } from "./ExcludedCascadeAccessView.vue?vue&type=template&id=edd96242"
import script from "./ExcludedCascadeAccessView.vue?vue&type=script&lang=js"
export * from "./ExcludedCascadeAccessView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports